// extracted by mini-css-extract-plugin
export var textInput = "_hp-0";